import { css } from '@mui/material';

export const globalStyles = css({
  'body, html, #root': {
    height: '100%',
  },
});
